import { ItemTypes } from "game-common/item/item_type"
import { ItemTypeMeta } from "../item/item"

import { Coordinate, MapSpriteCap, WeaponType } from "../models"
import { EntityTileTypes } from "../item/item_entity_tiles"

export interface MapDelta {
    x: number
    y: number
    blocking?: boolean
    occlusion?: boolean
    tileId?: string
    removed?: boolean
    layerId?: string
    surfaceId?: string
    mapSpriteCap?: MapSpriteCap
    temporary?: boolean
    collideable?: boolean
    context?: {
        parent?: Coordinate
        surfaceId?: string
        itemType?: ItemTypes
        hp?: number
        hpMax?: number
    }
}

export type TileEffectType = "damage" | "destroy" | "remove" | "overlay"

export interface TileEffect {
    mapRoughCoordinates: Coordinate
    effectType: TileEffectType
    surfaceId?: string
    tileId?: string
    overlayTileId?: string
    entityTile?: EntityTile
    hpPct?: number
    hp?: number
    hpMax?: number
}

export type EntityTile = (typeof EntityTileTypes)[number]

export const isTreeEntityTile = (tile: EntityTile) =>
    ["tree1", "tree2", "tree3", "tree4", "tree5", "smallTree1"].includes(tile)

interface GrowthDescriptor {
    entityTileId: EntityTile
    requiredTime: number
}

interface ItemCreationDescriptor {
    itemType: ItemTypeMeta
    quantity: number
    replicate?: boolean
    probability?: number
}

export interface EntityTileMeta {
    hp: number
    growthSequence?: GrowthDescriptor[]
    onDestructionCreateItems?: ItemCreationDescriptor[]
}

export type EntityTileDamageMeta = {
    weaponType: WeaponType
    damage: number
}
